<template>
  <a
    :data-id="`item-${item.title}`"
    @click.prevent="toggleDropdown(`item-${item.title}`)"
  >
    <v-tooltip :disabled="hasMainMenuOpen || isMobileDevice" right>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <span class="menu__item__icon" :class="`menu__item__icon--${item.icon}`" />
          <span class="menu__item__text">{{ $t(`${namespace}.${item.title}`) }}</span>
          <v-icon
            v-if="hasMainMenuOpen || isMobileDevice"
            class="menu__item__arrow"
            color="white"
            small
          >
            keyboard_arrow_right
          </v-icon>
        </span>
      </template>
      <span>{{ $t(`${namespace}.${item.title}`) }}</span>
    </v-tooltip>
  </a>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mediaQueries from 'mixins/mediaQueries'

export default {
  name: 'MenuDropdownAction',
  mixins: [mediaQueries],
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  },
  data () {
    return {
      namespace: 'Components.MainMenu'
    }
  },
  methods: {
    ...mapActions({
      handleMainManuToogle: 'mainMenu/toggle'
    }),

    toggleDropdown (elemId) {
      const submenu = document.querySelector(`[data-id=${elemId}]`).parentNode.parentNode

      if (!submenu.classList.contains('submenu__container--open')) {
        const items = document.querySelectorAll('.submenu__container')
        items.forEach(item => item.classList.remove('submenu__container--open'))
        submenu.classList.add('submenu__container--open')
      } else {
        submenu.classList.remove('submenu__container--open')
      }

      // if (!this.hasMainMenuOpen && !this.isMobileDevice) {
      if (!this.hasMainMenuOpen && !this.isMobileDevice) {
        this.handleMainManuToogle()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
